var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFooterBgRight = function SvgFooterBgRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2875_20363",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 600,
    height: 600
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600,
    fill: "url(#paint0_linear_2875_20363)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2875_20363)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 404,
    cy: 196,
    r: 196,
    fill: "#EDF3DD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 92,
    r: 92,
    transform: "matrix(1 0 0 -1 0 216)",
    fill: "#EBF1F8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 92,
    r: 92,
    transform: "matrix(1 0 0 -1 104 524)",
    fill: "#E3F0F1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    transform: "matrix(1 0 0 -1 104 316)",
    fill: "#EAE8F6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(1 0 0 -1 56 264)",
    fill: "#FCE6E0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2875_20363",
    x1: 300,
    y1: 0,
    x2: 300,
    y2: 600,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
};
export { SvgFooterBgRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAwIiBoZWlnaHQ9IjYwMCIgdmlld0JveD0iMCAwIDYwMCA2MDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIG9wYWNpdHk9IjAuMDUiPgo8bWFzayBpZD0ibWFzazBfMjg3NV8yMDM2MyIgc3R5bGU9Im1hc2stdHlwZTphbHBoYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMCIgeT0iMCIgd2lkdGg9IjYwMCIgaGVpZ2h0PSI2MDAiPgo8cmVjdCB3aWR0aD0iNjAwIiBoZWlnaHQ9IjYwMCIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyXzI4NzVfMjAzNjMpIi8+CjwvbWFzaz4KPGcgbWFzaz0idXJsKCNtYXNrMF8yODc1XzIwMzYzKSI+CjxjaXJjbGUgY3g9IjQwNCIgY3k9IjE5NiIgcj0iMTk2IiBmaWxsPSIjRURGM0REIi8+CjxjaXJjbGUgY3g9IjkyIiBjeT0iOTIiIHI9IjkyIiB0cmFuc2Zvcm09Im1hdHJpeCgxIDAgMCAtMSAwIDIxNikiIGZpbGw9IiNFQkYxRjgiLz4KPGNpcmNsZSBjeD0iOTIiIGN5PSI5MiIgcj0iOTIiIHRyYW5zZm9ybT0ibWF0cml4KDEgMCAwIC0xIDEwNCA1MjQpIiBmaWxsPSIjRTNGMEYxIi8+CjxjaXJjbGUgY3g9IjQwIiBjeT0iNDAiIHI9IjQwIiB0cmFuc2Zvcm09Im1hdHJpeCgxIDAgMCAtMSAxMDQgMzE2KSIgZmlsbD0iI0VBRThGNiIvPgo8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMiIgdHJhbnNmb3JtPSJtYXRyaXgoMSAwIDAgLTEgNTYgMjY0KSIgZmlsbD0iI0ZDRTZFMCIvPgo8L2c+CjwvZz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhcl8yODc1XzIwMzYzIiB4MT0iMzAwIiB5MT0iMCIgeDI9IjMwMCIgeTI9IjYwMCIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSJ3aGl0ZSIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IndoaXRlIiBzdG9wLW9wYWNpdHk9IjAiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K";